import { useState, useEffect } from 'react';

import { getShuffledData } from '@contentTransformation/helpers/contentGenerationHelpers';
import { EventType, UseRandomizedContentType } from '@event/types';

const useRandomizedContent = (
  selectedEventType: EventType | null,
  isDirty: boolean,
): UseRandomizedContentType => {
  const [eventTitle, setEventTitle] = useState<string>('');
  const [eventDescription, setEventDescription] = useState<string>('');
  const typeEnumValue = selectedEventType?.typeEnumValue || null;

  useEffect(() => {
    if (!isDirty) {
      const shuffledEventTitles = getShuffledData('title', typeEnumValue);
      const shuffledEventDescriptions = getShuffledData(
        'description',
        typeEnumValue,
      );

      setEventDescription(shuffledEventDescriptions[0]);
      setEventTitle(shuffledEventTitles[0]);
    }
  }, [isDirty, selectedEventType?.name, typeEnumValue]);

  return {
    eventTitle,
    eventDescription,
  };
};

export default useRandomizedContent;
